import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(() => ({
  root: {
    position: 'fixed',
    width: '100%',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    top: 0,
    backgroundColor: '#f5f5f578',
    left: 0,
    zIndex: 10000,
  },
}));

const Loader = ({ loading }) => {
  const classes = useStyles();
  return (
    loading
      ? (
        <div className={classes.root}>
          <CircularProgress />
        </div>
      )
      : null
  );
};

const mapState = (state) => ({
  loading: state.common.loading,
});

export default connect(mapState, null)(Loader);
